import { companyApplicant } from "../../../service/Scope/Scope";
import { v4 as uuidv4 } from "uuid";
import { APIClient } from "smartassess-api-lib";
import {
  geoLocationapiClient,
  getBrowserName,
} from "../../../utils/Common/Constant";
import { generateToken } from "../../../PushNotification/firebase";
import { CommonEnums } from "../../../utils/Enums/CommonEnums";

const handleApplicantLogin = async (
  email?: any,
  password?: any,
  loginType?: any,
  providerId?: any,
  isVerified?: any,
  resetForm?: () => void,
  setSubmitting?: (data: boolean) => any,
  navigate?: any,
  currentLanguage?: any,
  rechargeSlabID?: any,
  templateID?: any,
  partnerId?: any,
  setCompanyToken?: (data: string) => any,
) => {
  setSubmitting && setSubmitting(true);

  let geo: any = null;
  try {
    geo = await geoLocationapiClient();
  } catch {
    geo = null;
  }

  const token =
    getBrowserName() !== CommonEnums.BROWSER_SAFARI
      ? await generateToken()
      : null;
  const data = {
    emailId: email?.toLowerCase(),
    password: password?.trim(),
    loginType: loginType,
    providerId: providerId,
    isVerified: isVerified,
    partnerId: partnerId,
    deviceToken: token || null,
    IP: geo?.ip || "152.58.56.128",
    agent: getBrowserName(),
    deviceType: "web",
  };
  try {
    const sendInvitationRes = await companyApplicant(data);
    if (sendInvitationRes?.status === 200) {
      resetForm && resetForm();
      const uniqueId = uuidv4();
      setCompanyToken && setCompanyToken(sendInvitationRes?.data?.accessToken);
      localStorage.setItem(
        "companyToken",
        sendInvitationRes?.data?.accessToken,
      );
      APIClient.setApiToken(sendInvitationRes?.data?.accessToken);
      localStorage.setItem("companyId", sendInvitationRes?.data?.companyId);
      localStorage.setItem(
        "companyUserId",
        sendInvitationRes?.data?.companyUserId,
      );
      localStorage.setItem("industryId", sendInvitationRes?.data?.industryId);
      localStorage.setItem("tempUniqueId", uniqueId);
      localStorage.setItem("branchId", sendInvitationRes?.data?.branchId);
      localStorage.setItem("mediaPath", sendInvitationRes?.data?.mediaPath);
      localStorage.setItem("email", email?.toLowerCase());
      localStorage.setItem(
        "companyAddress",
        sendInvitationRes?.data?.address ?? "",
      );
      localStorage.setItem("sessionId", sendInvitationRes?.data?.sessionId);
      sessionStorage.removeItem("referredPartnerId");
      sessionStorage.removeItem("referredClientEmail");

      if (rechargeSlabID) {
        navigate(`/${currentLanguage}/account/account-details?rechrSlab=true`);
      } else if (templateID) {
        navigate(`/${currentLanguage}/assessment/template/${templateID}`, {
          state: { templateID: templateID },
        });
      } else {
        navigate(`/${currentLanguage}/jobs`, { replace: true });
      }
    }
  } catch (error) {
    console.error("Error submitting form:", error);
  } finally {
    setSubmitting && setSubmitting(false);
  }
};
export default handleApplicantLogin;
